import { render, staticRenderFns } from "./companiesDetails.vue?vue&type=template&id=033a72bd&scoped=true"
import script from "./companiesDetails.vue?vue&type=script&lang=js"
export * from "./companiesDetails.vue?vue&type=script&lang=js"
import style0 from "./companiesDetails.vue?vue&type=style&index=0&id=033a72bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033a72bd",
  null
  
)

export default component.exports